/* eslint-disable no-barrel-files/no-barrel-files -- TODO: Migrate to named exports */
import { Row } from "./components/Row";
import { AccessRegistryCardView } from "./skeletons/AccessRegistryCardView";
import { CommunityMemberAccessControlView } from "./skeletons/AdminMemberEditModal/Access/CommunityMemberAccessControlView";
import { AccessGroupCardControlView } from "./skeletons/AdminMemberEditModal/Access/CommunityMemberAccessControlView/AccessGroupCardControlView";
import { Bookmarks } from "./skeletons/Bookmarks";
import { CardView } from "./skeletons/CardView";
import { ChatThreadsListHeader } from "./skeletons/ChatThreadsListHeader";
import { Checklist } from "./skeletons/Checklist";
import { CommunitySidebar } from "./skeletons/CommunitySidebar";
import { CommunitySidebarSkeleton } from "./skeletons/CommunitySidebarV2";
import { CommunitySwitcherSkeleton } from "./skeletons/CommunitySwitcher";
import { EmailPreview } from "./skeletons/EmailPreview";
import { EventsListView } from "./skeletons/EventsListView";
import { EventItem } from "./skeletons/EventsListView/EventItem";
import { EventPopover } from "./skeletons/EventsListView/EventPopover";
import { NewEventDetail } from "./skeletons/EventsListView/NewEventDetail";
import { NewEventsListView } from "./skeletons/EventsListView/NewEventsListView";
import { NewEventsThumbnailView } from "./skeletons/EventsListView/NewEventsThumbnailView";
import { FeedView } from "./skeletons/FeedView";
import { FullPostView } from "./skeletons/FullPostView";
import { GridView } from "./skeletons/GridView";
import { ListView } from "./skeletons/ListView";
import { MainHeader } from "./skeletons/MainHeader";
import { MemberCard } from "./skeletons/MemberCard";
import { MembersAvatarRow } from "./skeletons/MembersAvatarRow";
import { MembersAvatarRowV3 } from "./skeletons/MembersAvatarRowV3";
import { ChatRoom } from "./skeletons/Messaging/ChatRoom";
import { ChatRoomSidebar } from "./skeletons/Messaging/ChatRoomSidebar";
import { ChatThread } from "./skeletons/Messaging/ChatThread";
import { ChatThreadsListPage } from "./skeletons/Messaging/ChatThreadsListPage";
import { MessagingListPage } from "./skeletons/Messaging/MessagingListPage";
import { MobileHomeSegments } from "./skeletons/MobileHomeSegments";
import { PlanSelector } from "./skeletons/PlanSelector";
import { RailBar } from "./skeletons/Rail";
import { RailMemberList } from "./skeletons/Rail/RailMemberList";
import { RailProfile } from "./skeletons/Rail/RailProfile";
import { RightSidebar } from "./skeletons/RightSidebar";
import { SpaceHeader } from "./skeletons/SpaceHeader";
import { SpaceMemberListPage } from "./skeletons/SpaceMemberListPage";
import { StorageDistribution } from "./skeletons/StorageDistribution";
import { Transcription } from "./skeletons/Transcription";
import { VerticalPlanCard } from "./skeletons/VerticalPlanCard";
import "./styles.scss";

export const variantToComponentMap = {
  "app-bar": MainHeader,
  "right-sidebar": RightSidebar,
  "feed-view": FeedView,
  "card-view": CardView,
  "grid-view": GridView,
  "list-view": ListView,
  "community-switcher": CommunitySwitcherSkeleton,
  "community-sidebar": CommunitySidebar,
  "community-sidebar-v2": CommunitySidebarSkeleton,
  "space-header": SpaceHeader,
  "member-card": MemberCard,
  "space-member-list-page": SpaceMemberListPage,
  "rail-bar": RailBar,
  "rail-member-list": RailMemberList,
  "rail-profile": RailProfile,
  "messaging-list-page": MessagingListPage,
  "chat-room": ChatRoom,
  "chat-thread": ChatThread,
  "chat-threads-list-page": ChatThreadsListPage,
  bookmarks: Bookmarks,
  transcription: Transcription,
  "full-post-view": FullPostView,
  "members-avatar-row": MembersAvatarRow,
  "members-avatar-row-v3": MembersAvatarRowV3,
  "events-list-view": EventsListView,
  "new-events-list-view": NewEventsListView,
  "new-events-thumbnail-view": NewEventsThumbnailView,
  "new-event-detail": NewEventDetail,
  "chat-room-sidebar": ChatRoomSidebar,
  "chat-threads-list-header": ChatThreadsListHeader,
  "email-preview": EmailPreview,
  "event-popover": EventPopover,
  "event-item": EventItem,
  row: Row,
  "access-registry-card": AccessRegistryCardView,
  "community-member-access-control": CommunityMemberAccessControlView,
  "community-member-access-group-card-control": AccessGroupCardControlView,
  "mobile-home-segments": MobileHomeSegments,
  "plan-selector": PlanSelector,
  "vertical-plan-card": VerticalPlanCard,
  "storage-distribution": StorageDistribution,
  checklist: Checklist,
} as const;

export type SkeletonVariant = keyof typeof variantToComponentMap;

export interface SkeletonLoaderProps {
  [key: string]: unknown;
  show?: boolean;
  variant: SkeletonVariant;
}

export const SkeletonLoader = ({
  variant,
  show = true,
  ...rest
}: SkeletonLoaderProps) => {
  const Component = variantToComponentMap[variant];
  if (!show || !Component) {
    return null;
  }
  return <Component {...rest} />;
};

export * from "./components/";
export * from "./skeletons/";
